import Vue from 'vue';
import ProductModule from "@/enums/productModule";
import ReportType from '@/enums/reportType';
import { formatTerm } from '@/terminology';

const state = {
	reports: [
		{
			name: 'ComplianceReport',
			friendlyName: 'Employee Compliance',
			icon: 'assignment_turned_in',
			roles: ['admin'],
			group: 'Compliance Reports',
			requiredModule: ProductModule.Compliance,
			reportType: ReportType.WEB
		},
		{
			name: 'PolicyAgreementsReport',
			friendlyName: 'Policy Agreements',
			icon: 'mdi-file-check-outline',
			roles: ['admin'],
			group: 'Compliance Reports',
			requiredModule: ProductModule.Compliance,
			reportType: ReportType.CSV
		},
		{
			name: 'PolicyVersionHistoryReport',
			friendlyName: 'Policy Version History',
			icon: 'mdi-history',
			roles: ['admin'],
			group: 'Compliance Reports',
			requiredModule: ProductModule.Compliance,
			reportType: ReportType.CSV
		},
		{
			name: 'GoalStatusReport',
			friendlyName: 'Goal Status',
			icon: 'mdi-bullseye-arrow',
			group: 'Employee Reports',
			requiredModule: ProductModule.Goals,
			reportType: ReportType.WEB
		},
		{
			name: 'PerformanceValuesReport',
			friendlyName: 'Performance vs Values',
			icon: 'mdi-chart-donut',
			group: 'Employee Reports',
			requiredModule: ProductModule.PerformanceReviews,
			reportType: ReportType.WEB
		},
		{
			name: 'EmployeeComplianceRemindersSentReport',
			friendlyName: 'Employee Compliance Reminders Sent',
			icon: 'mdi-email-check-outline',
			roles: ['admin'],
			group: 'System Reports',
			requiredModule: ProductModule.Compliance,
			reportType: ReportType.WEB
		}
	]
};

const getters = {
	availableReports(state, getters, rootState, rootGetters) {
		const employee = formatTerm(rootGetters.terminology, 'employee', { case: 'title' });
		return state.reports
			.filter(x => rootGetters.hasAccessToModule(x.requiredModule))
			.map(x => ({
				...x,
				friendlyName: x.friendlyName.replace(/Employee/g, employee),
				group: x.group.replace(/Employee/g, employee)
			}));
	}
};

const actions = {
	get({ rootState }, reportName) {
		return Vue.axios.get(`/api/${rootState.tenantId}/reports/${reportName}`);
	}
};

const mutations = {};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
